import { render } from "./GamePerformance.vue?vue&type=template&id=b233a1e2&scoped=true"
import script from "./GamePerformance.vue?vue&type=script&lang=js"
export * from "./GamePerformance.vue?vue&type=script&lang=js"

import "./GamePerformance.vue?vue&type=style&index=0&id=b233a1e2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\reportpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b233a1e2"]])

export default __exports__